import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {FaqCategory} from "../../model/FaqCategory";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";

@Injectable({
  providedIn: 'root'
})
export class CategoryFormGeneratorService implements FormGeneratorService {

  constructor() {
  }

  getQuestions(category: FaqCategory): Observable<FieldDefinition<any>[]> {
    const questions = [
      new FieldDefinition<string>({
        key: "backcolor",
        label: 'Couleur du fond',
        type: 'color-picker',
        value: category.backcolor,
        required: true,
        fullsize: false,
        order: 1
      }),
      new FieldDefinition<string>({
        key: 'textcolor',
        label: 'Couleur du texte',
        type: 'color-picker',
        value: category.textcolor,
        required: true,
        fullsize: false,
        order: 2
      }),
    ];
    return of(questions.sort((a, b) => a.order - b.order));
  }
}
